import EditNotice from  './EditNotice';
export default EditNotice;